import { Card } from '@/components/ui/card';
import { Check } from 'lucide-react';
import { headerFonts, type HeaderFont } from '@/config/fonts';
import { cn } from '@/lib/utils';
import { useEffect } from 'react';

interface FontSelectorProps {
  selectedFont: string;
  onFontChange: (fontId: string) => void;
  className?: string;
}

function FontPreview({ font, isSelected }: { font: HeaderFont; isSelected: boolean }) {
  // Load the font for preview
  useEffect(() => {
    const linkId = `font-preview-${font.id}`;
    if (!document.getElementById(linkId)) {
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = font.googleFontsUrl;
      document.head.appendChild(link);
    }
  }, [font]);

  return (
    <div 
      className="text-lg font-semibold"
      style={{ fontFamily: font.family }}
    >
      {font.name}
    </div>
  );
}

export function FontSelector({ selectedFont, onFontChange, className }: FontSelectorProps) {
  return (
    <div className={cn('grid gap-3 sm:grid-cols-2 lg:grid-cols-3', className)}>
      {headerFonts.map((font) => {
        const isSelected = selectedFont === font.id;
        return (
          <Card
            key={font.id}
            className={cn(
              'p-4 cursor-pointer transition-all hover:shadow-md relative',
              isSelected && 'ring-2 ring-primary border-primary'
            )}
            onClick={() => onFontChange(font.id)}
          >
            {isSelected && (
              <div className="absolute top-2 right-2 bg-primary text-primary-foreground rounded-full p-1">
                <Check className="h-3 w-3" />
              </div>
            )}
            <FontPreview font={font} isSelected={isSelected} />
            <p className="text-xs text-muted-foreground mt-2">
              Sample: The quick brown fox
            </p>
          </Card>
        );
      })}
    </div>
  );
}
